import { Button, Col, Row } from "reactstrap";
import SvgIcon from "../../CommonComponents/SvgIcon";
import { Href, LearnMore } from "../../../Constants/Constants";

const MessagesSecure = () => {
  return (
    <section className="section-pb-space secure-app-main">
      <div className="custom-container">
        <Row>
          <Col xl="5" lg="5" className="offset-xl-7 offset-lg-7">
            <div className="secure-app-content">
              <div>
                <div className="ply-main">
                  <div className="ply-content">
                    <SvgIcon className="fill-primary" iconId="landing-secure"/>
                  </div>
                  <h3>Secure Your <span>Messages</span></h3>
                </div>
                <h1>The world's top secure App</h1>
                <h4><span>Desktop App </span>– Easy to use our chat app, Attractive and clean design, with many Features :- Dark & light, Recent Chat And many more.......</h4>
                <Button tag={"a"} className="pricing-btn" href={Href}>{LearnMore}</Button>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
};

export default MessagesSecure;
